module.exports = __webpack_public_path__ + "school/img/practiceSeparatePhilosophyThemeBg.37357508.jpg";